import Vue from 'vue'
import axios from '@/plugins/axios'

export const findById = async (_, id) => {
  try {
    const { data } = await axios.get(`whatsapp-campaign/${id}`)

    return data
  } catch (err) {
    return err
  }
}

export const findAll = async (_, params = {}) => {
  try {
    const { data } = await axios.get('whatsapp-campaign', { params })

    return data || []
  } catch (err) {
    console.error('Erro ao buscar campanhas WhatsApp:', err)
    return []
  }
}

export const create = async (_, body) => {
  Vue.prototype.$loading(true)

  console.error('Body:', body)
  try {

    console.error('Body:', body)
    const formData = new FormData()
    
    // Adicionar campos do formulário
    formData.append('campaignName', body.campaignName)
    formData.append('profileName', body.profileName)
    formData.append('recipientType', body.recipientType)
    formData.append('messageContent', body.messageContent)
    formData.append('scheduleType', body.scheduleType)
    
    // Adicionar arquivos se existirem
    if (body.profilePhoto) {
      console.error('Adicionando profilePhoto ao FormData:', {
        name: body.profilePhoto.name,
        size: body.profilePhoto.size,
        type: body.profilePhoto.type,
        isFile: body.profilePhoto instanceof File
      })
      formData.append('profilePhoto', body.profilePhoto)
    } else {
      console.error('ERRO: profilePhoto está vazio ou undefined!', body.profilePhoto)
    }
    
    if (body.mediaFile) {
      formData.append('mediaFile', body.mediaFile)
    }
    
    // Adicionar campos opcionais
    if (body.buttonLink) {
      formData.append('buttonLink', body.buttonLink)
    }
    
    if (body.buttonName) {
      formData.append('buttonName', body.buttonName)
    }
    
    if (body.scheduledDate) {
      formData.append('scheduledDate', body.scheduledDate)
    }
    
    if (body.anonymizeRecipients !== undefined) {
      formData.append('anonymizeRecipients', body.anonymizeRecipients)
    }
    
    // Adicionar phones (contatos) - enviar como JSON em um único campo
    if (body.contacts && body.contacts.length > 0) {
      const phones = body.contacts.map(contact => {
        return String(contact.phone || contact)
      })

      // Evita multipart gigante e é compatível com o backend (transformer toArray faz parse de JSON)
      formData.append('phones', JSON.stringify(phones))
    }

    const { status } = await axios.post('whatsapp-campaign', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })

    return status
  } catch (err) {
    console.error('Erro ao criar campanha WhatsApp:', err)
    if (err.response) {
      console.error('Response error:', err.response.data)
    }
    return err
  } finally {
    Vue.prototype.$loading(false)
  }
}

export const finalize = async (_, { campaignId, reportFile }) => {
  Vue.prototype.$loading(true)
  try {
    const formData = new FormData()
    
    // Adicionar arquivo de relatório se existir
    if (reportFile) {
      formData.append('reportFile', reportFile)
    }
    
    await axios.post(`whatsapp-campaign/${campaignId}/finalize`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    return true
  } catch (err) {
    console.error('Erro ao finalizar campanha WhatsApp:', err)
    return err
  } finally {
    Vue.prototype.$loading(false)
  }
}

export const cancel = async (_, { campaignId, reportFile }) => {
  Vue.prototype.$loading(true)
  try {
    const formData = new FormData()
    
    // Adicionar arquivo de relatório se existir
    if (reportFile) {
      formData.append('reportFile', reportFile)
    }
    
    await axios.post(`whatsapp-campaign/${campaignId}/cancel`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    return true
  } catch (err) {
    console.error('Erro ao cancelar campanha WhatsApp:', err)
    return err
  } finally {
    Vue.prototype.$loading(false)
  }
}
